/* Component: IconClose
 * Author:    AM
 * Date:      28/07/2021
 *      Fixed version of the original IconClose
 *      This'll version will break any existing IconClose's that exist that rely on changing the viewport to appear correctly. Update with caution!
 */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const IconClose = ({
    size = 50,
    style,
    disabled = false,
    onClick,
    fill,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 50 50'
            xmlns='http://www.w3.org/2000/svg'
            onClick={onClick}
            fill={disabled ? '#cccccc' : fill}
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...props}
        >
            <path d='M20.064 24.84L0 44.905 5.096 50 24.84 29.936 44.904 50 50 44.904 29.936 24.841 50 5.096 44.904 0 24.841 20.064 5.096 0 0 5.096z' />
        </svg>
    );
};

IconClose.defaultProps = {
    disabled: false,
    size: 50
};

IconClose.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.any,
    style: PropTypes.object,
    fill: PropTypes.any
};

export default IconClose;
